import { render, staticRenderFns } from "./CargaTiempoReal.vue?vue&type=template&id=e2ef6c00&scoped=true"
import script from "./DashboardAlmacen.js?vue&type=script&lang=js&external"
export * from "./DashboardAlmacen.js?vue&type=script&lang=js&external"
import style0 from "./DashboardAlmacen.css?vue&type=style&index=0&id=e2ef6c00&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ef6c00",
  null
  
)

export default component.exports